import { appSettings } from 'app/appSettings';
import { Customer } from 'app/core/store/session/user-context/user-context.interface';
import { SapInvoice, SapInvoiceFromMW, SapInvoicesState } from '../../interfaces/sap-invoice.interface';
import * as actions from './sap-invoice.actions';

const initialState: SapInvoicesState = {
  loading: false,
  loaded: false,
  downloading: false,
  items: [],
  totalItems: null,
  filter: {
    type: '',
    pageSize: appSettings.PAGE_SIZE,
    pageNr: 1,
    sortField: 'invoiceDate',
    sortAscending: false,
    soldTo: 'all',
    currency: ['EUR'],
    invoiceDateFrom: null,
    invoiceDateTo: null,
    invoiceNumber: null,
    localCurrency: null,
    netAmountFrom: null,
    netAmountTo: null,
    euro: null,
  },
  valutas: [],
};

const mwToFeMapper = (invoiceFromMW: SapInvoiceFromMW, customers: Customer[]): SapInvoice => {
  const soldTo = customers.find(c => c.id === invoiceFromMW.soldTo);
  return {
    // If different, can be mapped here
    ...invoiceFromMW,
    soldToLabel: soldTo ? `${soldTo.id} ${soldTo.name}` : invoiceFromMW.soldTo,
  };
};

function queryInvoicesStart(state: SapInvoicesState, action: actions.QuerySapInvoicesStartAction): SapInvoicesState {
  return Object.assign({}, state, {
    loaded: false,
    loading: true,
    filter: action.payload.filter,
    items: [],
    totalItems: null,
  });
}

function queryInvoicesSuccess(state: SapInvoicesState, action: actions.QuerySapInvoicesSuccessAction): SapInvoicesState {
  return Object.assign({}, state, {
    loading: false,
    loaded: true,
    items: action.payload.invoices.items.map(i => mwToFeMapper(i, action.payload.customers)),
    totalItems: action.payload.invoices.totalItems,
  });
}

function invoiceDownload(state: SapInvoicesState, action: actions.SapInvoiceDownloadAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: true });
}

function invoiceDownloadSuccess(state: SapInvoicesState, action: actions.SapInvoiceDownloadSuccessAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadFail(state: SapInvoicesState, action: actions.SapInvoiceDownloadFailAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadList(state: SapInvoicesState, action: actions.SapInvoiceDownloadListAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: true });
}

function invoiceDownloadListSuccess(state: SapInvoicesState, action: actions.SapInvoiceDownloadListSuccessAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function invoiceDownloadListFail(state: SapInvoicesState, action: actions.SapInvoiceDownloadListFailAction): SapInvoicesState {
  return Object.assign({}, state, { downloading: false });
}

function getValutaForCustomersSuccess(state: SapInvoicesState, action: actions.GetValutaForCustomersSuccessAction): SapInvoicesState {
  return {
    ...state,
    valutas: action.payload.valutas,
  };
}

function setDefaultValuta(state: SapInvoicesState, action: actions.SetDefaultValutaAction): SapInvoicesState {
  return Object.assign({}, state, {
    valuta: [],
  });
}

function clearInvoicesFilter(state: SapInvoicesState): SapInvoicesState {
  return {
    ...initialState,
  };
}

export function reducer(state = initialState, action: actions.Actions): SapInvoicesState {
  let newState = state;
  switch (action.type) {
    case actions.QUERY_SAP_INVOICES_START:
      newState = queryInvoicesStart(state, action);
      break;
    case actions.QUERY_SAP_INVOICES_SUCCESS:
      newState = queryInvoicesSuccess(state, action);
      break;
    case actions.CLEAR_SAP_INVOICES_FILTER:
    case actions.QUERY_SAP_INVOICES_FAIL:
      newState = clearInvoicesFilter(state);
      break;
    case actions.SAP_INVOICE_DOWNLOAD: {
      newState = invoiceDownload(state, action);
      break;
    }
    case actions.SAP_INVOICE_DOWNLOAD_SUCCESS: {
      newState = invoiceDownloadSuccess(state, action);
      break;
    }
    case actions.SAP_INVOICE_DOWNLOAD_FAIL: {
      newState = invoiceDownloadFail(state, action);
      break;
    }
    case actions.SAP_INVOICE_DOWNLOAD_LIST: {
      newState = invoiceDownloadList(state, action);
      break;
    }
    case actions.SAP_INVOICE_DOWNLOAD_LIST_SUCCESS: {
      newState = invoiceDownloadListSuccess(state, action);
      break;
    }
    case actions.SAP_INVOICE_DOWNLOAD_LIST_FAIL: {
      newState = invoiceDownloadListFail(state, action);
      break;
    }
    case actions.GET_VALUTA_FOR_CUSTOMERS_SUCCESS: {
      newState = getValutaForCustomersSuccess(state, action);
      break;
    }
    case actions.SET_DEFAULT_VALUTA: {
      newState = setDefaultValuta(state, action);
      break;
    }
  }

  return newState;
}
